import React, { useState, useEffect } from "react";
import Footerlogo from "../../assets/images/footer-logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import axios from "axios";
import { api } from "../../Constant";

function Footer() {
  const [categorylist, setCategorylist] = useState([]);

  useEffect(() => {
    axios
      .post(api + "category_list")
      .then((response) => {
        if (response.data.success === "true") {
          setCategorylist(response.data.category);
        } else {
          console.log("No categories found");
        }
      })
      .catch((error) => {
        console.log("Error:", error);
      });
  }, []);

  return (
    <section className="footer_section pt-5">
      <div className="container">
        <div className="row pb-5">
          {/* Logo Section */}
          <div className="col-xl-3 col-lg-6 col-md-12 col-sm-12 left_col">
            <div className="inner-box">
              <Link to="/">
                <img src={Footerlogo} alt="footer-logo" />
              </Link>
            </div>
          </div>

          {/* Middle Columns */}
          <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 middle_col">
            <div className="row">
              {/* Order Details */}
              <div className="col-lg-4 col-md-4 col-sm-4 grid_col">
                <div className="inner-box">
                  <h6>Information</h6>
                  <div>
                    <ul>
                      <li>
                        <Link to="/Orders" className="text-decoration-none">
                          Order Details
                        </Link>
                      </li>
                      <li>
                        <Link to="/shipping-policy" className="text-decoration-none">
                          Shipping Policy
                        </Link>
                      </li>
                      <li>
                        <Link to="/refund-policy" className="text-decoration-none">
                          Refund Policy
                        </Link>
                      </li>
                      <li>
                        <Link to="/terms-conditions" className="text-decoration-none">
                          Terms & Conditions
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* About Us */}
              <div className="col-lg-4 col-md-4 col-sm-4 grid_col">
                <div className="inner-box">
                  <h6>About Us</h6>
                  <div>
                    <ul>
                      <li>
                        <Link to="/about" className="text-decoration-none">
                          About Us
                        </Link>
                      </li>
                      <li>
                        <Link to="/contact" className="text-decoration-none">
                          Contact Us
                        </Link>
                      </li>
                      <li>
                        <Link to="/privacy-policy" className="text-decoration-none">
                          Privacy Policy
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Quick Links */}
              <div className="col-lg-4 col-md-4 col-sm-4 grid_col">
                <div className="inner-box">
                  <h6>Quick Links</h6>
                  <div>
                    <ul>
                      {categorylist.slice(6, 9).map((item) => (
                        <li key={item.category_id}>
                          <Link to={`/category-page/${item.category_id}`} className="text-decoration-none">
                            {item.category_name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Newsletter */}
          <div className="col-xl-3 col-lg-6 col-md-12 col-sm-12 right_col">
            <div className="inner-box">
              <h6>Happy with our Service</h6>
              <div>
                <p>Let us Know...</p>
                <div className="input_box_main">
                  <input type="text" placeholder="Your Email Address" />
                  <span className="right_btn">
                    <FontAwesomeIcon icon={faArrowRight} />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="row footer-bottom pt-3 pb-3">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <p>© 2024 Shri Seyon Fabs All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Footer;
